import styled from 'styled-components'
import { Typography, WrapperRelative as WrapperRelativeDefault } from '~components'

export const Link = styled.a`
  cursor: pointer;
  text-decoration: none;
  font-size: ${({ theme }) => theme.font.size.m2};
  color: ${({ theme }) => theme.brand.text.default};
  font-weight: ${({ theme }) => theme.font.weight.medium};
`

export const WrapperRelative = styled(WrapperRelativeDefault)`
  input:not(:last-child) {
    padding: ${({ theme }) => theme.spacing.km0} ${({ theme }) => theme.spacing.km10}
      ${({ theme }) => theme.spacing.km0} ${({ theme }) => theme.spacing.km3};
  }

  &
    > input:not(:focus)
    + svg:is([aria-label='show-password'], [aria-label='hide-password']) {
    & > path {
      stroke: #7b829d;
    }
  }

  &
    > input:not(:placeholder-shown)
    + svg:is([aria-label='show-password'], [aria-label='hide-password']) {
    & > path {
      stroke: #232b43;
    }
  }
`

export const Message = styled(Typography).attrs({ as: 'p' })`
  font-weight: ${({ theme }) => theme.font.weight.medium};
  color: ${({ theme }) => theme.neutral.text.default};
`
